import { render, staticRenderFns } from "./seo.vue?vue&type=template&id=8c5f99ae&scoped=true"
import script from "./seo.vue?vue&type=script&lang=js"
export * from "./seo.vue?vue&type=script&lang=js"
import style0 from "./seo.vue?vue&type=style&index=0&id=8c5f99ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5f99ae",
  null
  
)

export default component.exports